import $ from "jquery";

const modalShow = function () {
  if ($.fn.fullpage.setAllowScrolling) $.fn.fullpage.setAllowScrolling(false);
};

const modalHide = function () {
  if ($.fn.fullpage.setAllowScrolling) $.fn.fullpage.setAllowScrolling(true);
};

export default function (modal) {
  $(modal)
    .on("show.bs.modal", modalShow)
    .on("hide.bs.modal", modalHide);
}
